import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSnackBar,
} from "@angular/material";
import { SessionStorage } from "ngx-webstorage";
import { Observable } from "rxjs/Observable";
import { DeletePopUpComponent } from "../../common/delete-pop-up/delete-pop-up.component";
import { EmployeesService } from "./employees.service";
import { EditTimesheetService } from "../edit-timesheet/edit-timesheet.service";
import { UpdateEmployee, ExportEmployee, ExportIpdoEmployee } from "./employee";
import { EmpList, EmpDetails } from "../admin.interface";
import { ExportExcelService } from "../../utils/services/export-excel.service";
import "rxjs/add/operator/takeWhile";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { switchMap } from "rxjs/operator/switchMap";

@Component({
  selector: "app-employees",
  templateUrl: "./employees.component.html",
  styleUrls: ["./employees.component.css"],
})
export class EmployeesComponent implements OnInit, OnDestroy {
  @SessionStorage() public userObj;
  @SessionStorage() public config; // Logged in user config
  @SessionStorage() public user; // Logged in user details

  public pageNumber: number = 1; // Page number for pagination purpose
  public totalElements: number = 0; // To set the pagination count
  public employeelist: EmpList[] = []; // Employee list for table view
  public employeeSearch: string = ""; // Search Item variable
  public submitted: boolean = false; // Flag for update/ edit submitted
  public editOpenCount: number = 0; // Count to restrict Multiple modal
  public rmListarray: any = []; // List of Rm available in system
  private alive: boolean = true; // Variable to subscribe/ unsubscribe
  public filteredOptions: Observable<string[]>; // Auto complete for RM user
  public employeeDetails: EmpDetails = new EmpDetails(""); // Edit employee info object
  public employeeConfig;
  public editEmployeeConfig;
  public employeesStatus;
  public totalEmployees :Boolean;

  constructor(
    private employeesService: EmployeesService,
    private editTimesheetService: EditTimesheetService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private exportExcel: ExportExcelService,
    private activeRoute: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((p) => {
      this.totalEmployees=p["totalemployees"];
      this.employeeConfig = true;
      this.editEmployeeConfig = true;
      this.getEmployeelist(); // Call methods or perform actions based on the new query parameters
      this.getrmList();
      this.employeesStatus = "active";

    });



    // this.employeeConfig = this.config.employee;
    // this.editEmployeeConfig = this.config.employee.editEmployee;

    // if (
    //   this.config.businessUnit === "ipdo" ||
    //   this.config.businessUnit === "biologics" ||
    //   this.config.businessUnit === "chinateam" ||
    //   this.config.businessUnit === "aps"
    // ) {
    //   this.employeeConfig = true;
    //   this.editEmployeeConfig = true;
    // } else if (this.config.businessUnit === "accenture") {
    //   this.employeeConfig = false;
    //   this.editEmployeeConfig = false;
    // }

    // this.getEmployeelist();
    // this.getrmList();
  }

  /**
   * @function getEmployeeList
   * @description
   * The function to obtain the the list og employee in the organizagion and store it in variable
   * @var employeelist the variable to store the list obtained from Backend API call
   * @var totalElements variable to store the total employee available in DB for pagination purpose
   * @method post
   * @param pageNumber for the purpose of BAckend pagination
   * @argument null
   * @class Emplist interface is used to define the format of the employee detail required for display
   * @author gaurav.rao
   */
  getEmployeelist() {
    this.employeelist = [];
    this.spinnerService.show();
    this.employeesService
      .getEmployeesDetails(this.pageNumber, this.employeesStatus,this.totalEmployees,null,null)
      .takeWhile(() => this.alive)
      .subscribe(
        (response) => {
          this.spinnerService.hide();
          this.totalElements = response.payload.totalemployees
            ? response.payload.totalemployees
            : 0;
          if (response.payload.employees) {
            response.payload.employees.map((value) =>
              this.employeelist.push(new EmpList(value))
            );
          }
        },
        (error) => {
          this.spinnerService.hide();
          this.snackBar.open("Error retriving the Employee list", "", {
            duration: 300,
          });
          this.employeelist.length = 0;
        }
      );
  }

  /**
   * @function checkSearchData
   * @description
   * The function to check data in the search field
   * @author Abhiraj SN
   */
  checkSearchData() {
    if (!this.employeeSearch) {
      this.pageNumber = 1;
      this.getEmployeelist();
    }
  }

  /**
   * @function applySearch
   * @description
   * Function used to search the employee as per the admin input in the search field
   * API is called to get the desired employee list
   * @var totalElements the variable to store the length of the employee available for pagination purpose
   * @var employeelist the variable to store the list obtained from Backend API call
   * @method post
   * @param  employeeSearch a search text entered by the admin
   * @class Emplist interface is used to define the format of the employee detail required for display
   * @author gaurav.rao
   */
  applySearch() {
    if (this.employeeSearch) {
      this.employeelist = [];
      this.employeesService
        .searchFilter(this.employeeSearch.trim(), this.employeesStatus)
        .takeWhile(() => this.alive)
        .subscribe(
          (response) => {
            this.totalElements = response.payload.employees;
            if (response.payload) {
              response.payload.employees.map((value) =>
                this.employeelist.push(new EmpList(value))
              );
            }
          },
          (error) => {
            this.snackBar.open("No Employee list found", "", {
              duration: 3000,
            });
          }
        );
    }
  }

  /* Navigate to Add employee page upon click of respective button */
  addEmployee() {
    this.router.navigate(["/admin/employees/add-employee"]);
  }

  /**
   * @function deleteTask
   * @description
   * Function  to delete the Single employee as per the click event by the admin.
   * Delete is achieved when the edit mode is not enabled
   * @argument employee single employee object of the clicked delete row element
   * @argument flag Valid flag to check whether edit mode is enabled or not.(true=> Enabled)
   * @method post
   * @param employee Single Employee object with Id, name etc.,
   * @extends DeletePopUpComponent a alert popup with Yes/No respective actions
   * @author gaurav.rao
   */
  deleteTask(employee, flag) {
    if (!flag) {
      if (this.dialog.openDialogs.length === 0) {
        const dialogRef = this.dialog.open(DeletePopUpComponent);
        dialogRef.afterClosed().subscribe((result) => {
          if (result == true) {
            this.employeesService
              .deleteEmployee(employee, this.userObj)
              .takeWhile(() => this.alive)
              .subscribe(
                (response) => {
                  this.snackBar.open("Employee deleted successfully", "", {
                    duration: 3000,
                  });
                  this.getEmployeelist();
                },
                (error) => {
                  this.snackBar.open("Error deleting the Employee", "", {
                    duration: 3000,
                  });
                }
              );
          }
        });
      }
    }
  }

  /**
   * @function updateTask
   * @description
   * Function to open the edit popup to edit the particular employee detail
   * @param i Index of the selected employee based on the list obtained
   * @var editOpenCount The flag count to disable the popup to open when already edit option is enabled
   * @var employeeDetails The Object of selected employee for edit view option
   * @author gaurav.rao
   */
  updateTask(i) {
    if (this.editOpenCount < 1) {
      this.employeelist[i].editMode = true;
      this.employeeDetails = new EmpDetails(this.employeelist[i]);
      this.editOpenCount++;
    }
  }

  /**
   * @function updateEmployee()
   * @description
   * Function to update the employee detail after editing the detail for the selected employee
   * @param empDetails The updated employee detail after editing the original employee object
   * @param i Index of the employee selected for the editing
   * @param valid a boolean flag to check validation of the edit form
   * @var submitted A boolean flag to check value is submited for update or not
   * @var editMode a boolean flag to to show or hide edit popup
   * @author gaurav.rao
   */
  updateEmployee(empDetails, i, valid) {
    /* A flag to show error upon submission */
    this.submitted = true;
    if (!valid) {
      // If edit form is invalid keep the popup open
      this.employeelist[i].editMode = true;
    } else {
      // Formatting the updated data by admin as per the Backend format
      const data = new UpdateEmployee(empDetails, this.employeeDetails);
      // Upadting the userdetails for data to be sent to Back-end
      data.updateItems.userObj = this.userObj;
      if (data.updateItems.RMname == "") {
        data.updateItems.RMCode = null;
      }
      this.employeesService
        .updateEmployee(data)
        .takeWhile(() => this.alive)
        .subscribe(
          (response) => {
            this.snackBar.open("Employee updated successfully", "", {
              duration: 3000,
            });
            // Boolean flag to hide the error flag after successful call
            this.submitted = false;
            this.employeeSearch = "";
            this.employeelist[i].editMode = false; // Hide the edit popup
            this.getEmployeelist(); // Get the updated employee list for view
            this.editOpenCount--;
          },
          (error) => {
            this.snackBar.open("Error updating the employee", "", {
              duration: 3000,
            });
          }
        );
    }
  }

  /**
   * @function exportXsl()
   * @description
   * A function to export the complete employee detail to CSV format
   * Data to CSV is called using the API directly
   * @var exportData An Array of object which store the data to be exported
   * @requires JSONToCSVCovertor An service file which creates the csv file and download it
   * @class ExportEmployee An class to create an object according to the field required for the CSV file
   * @author gaurav.rao
   */
  exportToXsl() {
    const exportData = [];
    this.spinnerService.show();
    this.employeesService
      .getEmployeesDetailsForExport(this.employeesStatus,this.totalEmployees)
      .takeWhile(() => this.alive)
      .subscribe(
        (data) => {
          this.spinnerService.hide();
          if (data.payload.employees) {
            if (this.config.businessUnit === "accenture") {
              data.payload.employees.map((value) =>
                exportData.push(new ExportEmployee(value))
              );
              this.exportExcel.JSONToCSVConvertor(
                exportData,
                "Employee",
                "Employee Details",
                true,
                true
              );
            } else if (
              this.config.businessUnit === "ipdo" ||
              this.config.businessUnit === "biologics" ||
              this.config.businessUnit === "chinateam" ||
              this.config.businessUnit === "aps"
            ) {
              data.payload.employees.map((value) =>
                exportData.push(
                  new ExportIpdoEmployee(value, this.config.businessUnit)
                )
              );
              this.exportExcel.JSONToCSVConvertor(
                exportData,
                "Employee",
                "Employee Details",
                true,
                true
              );
            }
          }
        },
        (error) => {
          this.spinnerService.hide();
          this.snackBar.open("Error downloading the Employee list", "", {
            duration: 3000,
          });
        }
      );
  }

  /**
   * @function triggerChange()
   * @description
   * A function called upon change of pagination by admin
   * @param data The variable which holds the page number has per the Admin click events
   * @var pageNumber A variable to store the selected page from pagination tab
   * @requires getEmployeelist A function is called upon every change in pagination event triggered
   * @author gaurav.rao
   */
  triggerChange(data: any) {
    this.pageNumber = data;
    if (this.employeeSearch) {
      this.applySearch();
    } else {
      this.getEmployeelist();
    }
  }

  /**
   * @function closeAll()
   * @description A function to be called upon click on close in the view inorder to hide the edit popup.
   * Close the edit popup flag and decrease the total edit popup open count
   * @param i Index of the employee list selected for edit purpose
   */
  closeAll(i) {
    this.editOpenCount--;
    this.employeelist[i].editMode = false;
    this.getEmployeelist();
  }

  /**
   * @function filterEntities
   * @description
   * A function to get the Reproting manager list as per the key entered ie auto complete feature
   * @param event $event object as per the admin input on the Rm input box
   * @var filteredOptions An array of object to store the matched RM list for view purpose
   * @author gaurav.rao
   */
  filterEntities(event: any) {
    const searchItem = event.target.value;
    if (event.target.value !== "undefined") {
      this.filteredOptions = this.rmListarray.filter(
        (s) => s.Empname.toLowerCase().indexOf(searchItem.toLowerCase()) == 0
      );
    }
  }

  /**
   * @function getrmList()
   * @description
   * Function to get all the Reporting managger from the backend and store it in a Array of object
   * @var rmListarray An array of object to store the list of rm obtained from api
   * @author gaurav.rao
   */
  getrmList() {
    this.employeesService
      .getrmList()
      .takeWhile(() => this.alive)
      .subscribe(
        (response) => {
          if (response.payload) {
            response.payload.map((value) => this.rmListarray.push(value));
          }
        },
        (error) => {
          this.snackBar.open("Error retriving the RM List", "", {
            duration: 3000,
          });
        }
      );
  }

  /**
   * @function changeReportManager()
   * @description
   * A function called when the admin selects the Reporting manager from the dropdown list of the auto complete
   * @param selectedoption An Object whcih hold the value of the selected reporting manager from the auto complete dropdown list
   * @var reportingMangerId An variable to hold the RMcode of the selected RM
   * @author gaurav.rao
   */
  changeReportManager(selectedoption) {
    this.employeeDetails.reportingManagerId = selectedoption.Empno;
  }

  /**
   * @function resetPwd
   * @description
   * An function to reset the password the employee selectedupon click of reset icon from the view
   * @param employee An object which holds the value of the employee selected to change the password
   * @author gaurav.rao
   * @version 1.0.0
   */
  resetPwd(employee) {
    this.employeesService
      .resetPwd(employee)
      .takeWhile(() => this.alive)
      .subscribe(
        (response) => {
          this.snackBar.open("Password resetted to default successfully", "", {
            duration: 3000,
            extraClasses: ["textCenter"],
          });
        },
        (error) => {
          this.snackBar.open("Error resetting the password", "", {
            duration: 3000,
          });
        }
      );
  }

  /**
   * @function ngOnDestroy()
   * @description
   * Function to destroy the Subscription used while calling API
   * Unsubscribe the observable is done using takeUntil method of rxjs
   * @author gaurav.rao
   */
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/employees/employees.component.ts